/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * Evals API
 * The Evals API description
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  CategoriesResponse,
  ConversationResponse,
  CountResponse,
  CreateCategoryRequest,
  CreateCategoryResponse,
  CreateDatasetRequest,
  CreateDatasetResponse,
  DatasetsParams,
  FeedbackHistoryResponse,
  FeedbackRequest,
  FeedbackResponse,
  Files,
  LoginRequest,
  LoginResponse,
  MessageRequest,
  MessageResponse,
  MetricResponse,
  MetricsResponse,
  OffsetPaginatedResultZod,
  PaginatedThreadsResponse,
  ThreadResponse,
  ThreadsParams,
  ThreadsResponse,
  TracesResponse
} from './generated.schemas';

import { useCustomClient } from './instance';
import type { ErrorType , BodyType } from './instance';




/**
 * @summary Login
 */
export const useLoginHook = () => {
        const login = useCustomClient<LoginResponse>();

        return useCallback((
    loginRequest: BodyType<LoginRequest>,
 signal?: AbortSignal
) => {
        return login(
          {url: `/api/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginRequest, signal
    },
          );
        }, [login])
      }
    


export const useLoginMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useLoginHook>>>, TError,{data: BodyType<LoginRequest>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useLoginHook>>>, TError,{data: BodyType<LoginRequest>}, TContext> => {
    
const mutationKey = ['login'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const login =  useLoginHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useLoginHook>>>, {data: BodyType<LoginRequest>}> = (props) => {
          const {data} = props ?? {};

          return  login(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useLoginHook>>>>
    export type LoginMutationBody = BodyType<LoginRequest>
    export type LoginMutationError = ErrorType<unknown>

    /**
 * @summary Login
 */
export const useLogin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useLoginHook>>>, TError,{data: BodyType<LoginRequest>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useLoginHook>>>,
        TError,
        {data: BodyType<LoginRequest>},
        TContext
      > => {

      const mutationOptions = useLoginMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useAuthControllerProfileHook = () => {
        const authControllerProfile = useCustomClient<unknown>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return authControllerProfile(
          {url: `/api/auth/profile`, method: 'GET', signal
    },
          );
        }, [authControllerProfile])
      }
    

export const getAuthControllerProfileQueryKey = () => {
    return [`/api/auth/profile`] as const;
    }

    
export const useAuthControllerProfileQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthControllerProfileQueryKey();

  const authControllerProfile =  useAuthControllerProfileHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>> = ({ signal }) => authControllerProfile(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthControllerProfileQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>>
export type AuthControllerProfileQueryError = ErrorType<void>


export function useAuthControllerProfile<TData = Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerProfile<TData = Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerProfile<TData = Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuthControllerProfile<TData = Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useAuthControllerProfileQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a new dataset
 */
export const useCreateDatasetHook = () => {
        const createDataset = useCustomClient<CreateDatasetResponse>();

        return useCallback((
    createDatasetRequest: BodyType<CreateDatasetRequest>,
 signal?: AbortSignal
) => {
        return createDataset(
          {url: `/api/datasets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDatasetRequest, signal
    },
          );
        }, [createDataset])
      }
    


export const useCreateDatasetMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateDatasetHook>>>, TError,{data: BodyType<CreateDatasetRequest>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateDatasetHook>>>, TError,{data: BodyType<CreateDatasetRequest>}, TContext> => {
    
const mutationKey = ['createDataset'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createDataset =  useCreateDatasetHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateDatasetHook>>>, {data: BodyType<CreateDatasetRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createDataset(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDatasetMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateDatasetHook>>>>
    export type CreateDatasetMutationBody = BodyType<CreateDatasetRequest>
    export type CreateDatasetMutationError = ErrorType<void>

    /**
 * @summary Create a new dataset
 */
export const useCreateDataset = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateDatasetHook>>>, TError,{data: BodyType<CreateDatasetRequest>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateDatasetHook>>>,
        TError,
        {data: BodyType<CreateDatasetRequest>},
        TContext
      > => {

      const mutationOptions = useCreateDatasetMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get all datasets
 */
export const useDatasetsHook = () => {
        const datasets = useCustomClient<OffsetPaginatedResultZod>();

        return useCallback((
    params?: DatasetsParams,
 signal?: AbortSignal
) => {
        return datasets(
          {url: `/api/datasets`, method: 'GET',
        params, signal
    },
          );
        }, [datasets])
      }
    

export const getDatasetsQueryKey = (params?: DatasetsParams,) => {
    return [`/api/datasets`, ...(params ? [params]: [])] as const;
    }

    
export const useDatasetsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>, TError = ErrorType<void>>(params?: DatasetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDatasetsQueryKey(params);

  const datasets =  useDatasetsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>> = ({ signal }) => datasets(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DatasetsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>>
export type DatasetsQueryError = ErrorType<void>


export function useDatasets<TData = Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>, TError = ErrorType<void>>(
 params: undefined |  DatasetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasets<TData = Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>, TError = ErrorType<void>>(
 params?: DatasetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasets<TData = Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>, TError = ErrorType<void>>(
 params?: DatasetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all datasets
 */

export function useDatasets<TData = Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>, TError = ErrorType<void>>(
 params?: DatasetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDatasetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDatasetsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get files
 */
export const useFilesHook = () => {
        const files = useCustomClient<Files>();

        return useCallback((
    datasetId: string,
 signal?: AbortSignal
) => {
        return files(
          {url: `/api/datasets/${datasetId}/files`, method: 'GET', signal
    },
          );
        }, [files])
      }
    

export const getFilesQueryKey = (datasetId: string,) => {
    return [`/api/datasets/${datasetId}/files`] as const;
    }

    
export const useFilesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useFilesHook>>>, TError = ErrorType<void>>(datasetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFilesQueryKey(datasetId);

  const files =  useFilesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFilesHook>>>> = ({ signal }) => files(datasetId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(datasetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FilesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useFilesHook>>>>
export type FilesQueryError = ErrorType<void>


export function useFiles<TData = Awaited<ReturnType<ReturnType<typeof useFilesHook>>>, TError = ErrorType<void>>(
 datasetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useFilesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useFilesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFiles<TData = Awaited<ReturnType<ReturnType<typeof useFilesHook>>>, TError = ErrorType<void>>(
 datasetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useFilesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useFilesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFiles<TData = Awaited<ReturnType<ReturnType<typeof useFilesHook>>>, TError = ErrorType<void>>(
 datasetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get files
 */

export function useFiles<TData = Awaited<ReturnType<ReturnType<typeof useFilesHook>>>, TError = ErrorType<void>>(
 datasetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFilesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useFilesQueryOptions(datasetId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get total files
 */
export const useCountFilesHook = () => {
        const countFiles = useCustomClient<CountResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return countFiles(
          {url: `/api/files/count`, method: 'GET', signal
    },
          );
        }, [countFiles])
      }
    

export const getCountFilesQueryKey = () => {
    return [`/api/files/count`] as const;
    }

    
export const useCountFilesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountFilesQueryKey();

  const countFiles =  useCountFilesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>> = ({ signal }) => countFiles(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountFilesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>>
export type CountFilesQueryError = ErrorType<void>


export function useCountFiles<TData = Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountFiles<TData = Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountFiles<TData = Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get total files
 */

export function useCountFiles<TData = Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountFilesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useCountFilesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a new category
 */
export const useCreateCategoryHook = () => {
        const createCategory = useCustomClient<CreateCategoryResponse>();

        return useCallback((
    createCategoryRequest: BodyType<CreateCategoryRequest>,
 signal?: AbortSignal
) => {
        return createCategory(
          {url: `/api/categories`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCategoryRequest, signal
    },
          );
        }, [createCategory])
      }
    


export const useCreateCategoryMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateCategoryHook>>>, TError,{data: BodyType<CreateCategoryRequest>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateCategoryHook>>>, TError,{data: BodyType<CreateCategoryRequest>}, TContext> => {
    
const mutationKey = ['createCategory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createCategory =  useCreateCategoryHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateCategoryHook>>>, {data: BodyType<CreateCategoryRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createCategory(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCategoryMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateCategoryHook>>>>
    export type CreateCategoryMutationBody = BodyType<CreateCategoryRequest>
    export type CreateCategoryMutationError = ErrorType<void>

    /**
 * @summary Create a new category
 */
export const useCreateCategory = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateCategoryHook>>>, TError,{data: BodyType<CreateCategoryRequest>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateCategoryHook>>>,
        TError,
        {data: BodyType<CreateCategoryRequest>},
        TContext
      > => {

      const mutationOptions = useCreateCategoryMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get all categories
 */
export const useCategoriesHook = () => {
        const categories = useCustomClient<CategoriesResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return categories(
          {url: `/api/categories`, method: 'GET', signal
    },
          );
        }, [categories])
      }
    

export const getCategoriesQueryKey = () => {
    return [`/api/categories`] as const;
    }

    
export const useCategoriesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCategoriesQueryKey();

  const categories =  useCategoriesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>> = ({ signal }) => categories(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CategoriesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>>
export type CategoriesQueryError = ErrorType<void>


export function useCategories<TData = Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCategories<TData = Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCategories<TData = Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all categories
 */

export function useCategories<TData = Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useCategoriesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get total categories
 */
export const useCountCategoriesHook = () => {
        const countCategories = useCustomClient<CountResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return countCategories(
          {url: `/api/categories/count`, method: 'GET', signal
    },
          );
        }, [countCategories])
      }
    

export const getCountCategoriesQueryKey = () => {
    return [`/api/categories/count`] as const;
    }

    
export const useCountCategoriesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountCategoriesQueryKey();

  const countCategories =  useCountCategoriesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>> = ({ signal }) => countCategories(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountCategoriesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>>
export type CountCategoriesQueryError = ErrorType<void>


export function useCountCategories<TData = Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountCategories<TData = Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountCategories<TData = Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get total categories
 */

export function useCountCategories<TData = Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountCategoriesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useCountCategoriesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get category metrics
 */
export const useCategoryMetricsHook = () => {
        const categoryMetrics = useCustomClient<MetricsResponse>();

        return useCallback((
    categoryId: string,
 signal?: AbortSignal
) => {
        return categoryMetrics(
          {url: `/api/metrics/categories/${categoryId}`, method: 'GET', signal
    },
          );
        }, [categoryMetrics])
      }
    

export const getCategoryMetricsQueryKey = (categoryId: string,) => {
    return [`/api/metrics/categories/${categoryId}`] as const;
    }

    
export const useCategoryMetricsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>, TError = ErrorType<void>>(categoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCategoryMetricsQueryKey(categoryId);

  const categoryMetrics =  useCategoryMetricsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>> = ({ signal }) => categoryMetrics(categoryId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(categoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CategoryMetricsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>>
export type CategoryMetricsQueryError = ErrorType<void>


export function useCategoryMetrics<TData = Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>, TError = ErrorType<void>>(
 categoryId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCategoryMetrics<TData = Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>, TError = ErrorType<void>>(
 categoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCategoryMetrics<TData = Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>, TError = ErrorType<void>>(
 categoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get category metrics
 */

export function useCategoryMetrics<TData = Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>, TError = ErrorType<void>>(
 categoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoryMetricsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useCategoryMetricsQueryOptions(categoryId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get total conversations
 */
export const useTotalConversationsHook = () => {
        const totalConversations = useCustomClient<MetricResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return totalConversations(
          {url: `/api/metrics/total-conversations`, method: 'GET', signal
    },
          );
        }, [totalConversations])
      }
    

export const getTotalConversationsQueryKey = () => {
    return [`/api/metrics/total-conversations`] as const;
    }

    
export const useTotalConversationsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTotalConversationsQueryKey();

  const totalConversations =  useTotalConversationsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>> = ({ signal }) => totalConversations(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TotalConversationsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>>
export type TotalConversationsQueryError = ErrorType<void>


export function useTotalConversations<TData = Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTotalConversations<TData = Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTotalConversations<TData = Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get total conversations
 */

export function useTotalConversations<TData = Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTotalConversationsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useTotalConversationsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get unique users
 */
export const useUniqueUsersHook = () => {
        const uniqueUsers = useCustomClient<MetricResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return uniqueUsers(
          {url: `/api/metrics/unique-users`, method: 'GET', signal
    },
          );
        }, [uniqueUsers])
      }
    

export const getUniqueUsersQueryKey = () => {
    return [`/api/metrics/unique-users`] as const;
    }

    
export const useUniqueUsersQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUniqueUsersQueryKey();

  const uniqueUsers =  useUniqueUsersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>> = ({ signal }) => uniqueUsers(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UniqueUsersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>>
export type UniqueUsersQueryError = ErrorType<void>


export function useUniqueUsers<TData = Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUniqueUsers<TData = Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUniqueUsers<TData = Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get unique users
 */

export function useUniqueUsers<TData = Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUniqueUsersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useUniqueUsersQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get feedback conclusion
 */
export const useFeedbackConclusionHook = () => {
        const feedbackConclusion = useCustomClient<MetricResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return feedbackConclusion(
          {url: `/api/metrics/feedback-conclusion`, method: 'GET', signal
    },
          );
        }, [feedbackConclusion])
      }
    

export const getFeedbackConclusionQueryKey = () => {
    return [`/api/metrics/feedback-conclusion`] as const;
    }

    
export const useFeedbackConclusionQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeedbackConclusionQueryKey();

  const feedbackConclusion =  useFeedbackConclusionHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>> = ({ signal }) => feedbackConclusion(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FeedbackConclusionQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>>
export type FeedbackConclusionQueryError = ErrorType<void>


export function useFeedbackConclusion<TData = Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeedbackConclusion<TData = Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeedbackConclusion<TData = Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get feedback conclusion
 */

export function useFeedbackConclusion<TData = Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFeedbackConclusionHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useFeedbackConclusionQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a new thread
 */
export const useCreateThreadHook = () => {
        const createThread = useCustomClient<ThreadResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return createThread(
          {url: `/api/threads`, method: 'POST', signal
    },
          );
        }, [createThread])
      }
    


export const useCreateThreadMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateThreadHook>>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateThreadHook>>>, TError,void, TContext> => {
    
const mutationKey = ['createThread'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createThread =  useCreateThreadHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateThreadHook>>>, void> = () => {
          

          return  createThread()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateThreadMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateThreadHook>>>>
    
    export type CreateThreadMutationError = ErrorType<void>

    /**
 * @summary Create a new thread
 */
export const useCreateThread = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateThreadHook>>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateThreadHook>>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = useCreateThreadMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get all threads
 */
export const useThreadsHook = () => {
        const threads = useCustomClient<PaginatedThreadsResponse>();

        return useCallback((
    params?: ThreadsParams,
 signal?: AbortSignal
) => {
        return threads(
          {url: `/api/threads`, method: 'GET',
        params, signal
    },
          );
        }, [threads])
      }
    

export const getThreadsQueryKey = (params?: ThreadsParams,) => {
    return [`/api/threads`, ...(params ? [params]: [])] as const;
    }

    
export const useThreadsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>, TError = ErrorType<void>>(params?: ThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getThreadsQueryKey(params);

  const threads =  useThreadsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>> = ({ signal }) => threads(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ThreadsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>>
export type ThreadsQueryError = ErrorType<void>


export function useThreads<TData = Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>, TError = ErrorType<void>>(
 params: undefined |  ThreadsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useThreads<TData = Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>, TError = ErrorType<void>>(
 params?: ThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useThreads<TData = Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>, TError = ErrorType<void>>(
 params?: ThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all threads
 */

export function useThreads<TData = Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>, TError = ErrorType<void>>(
 params?: ThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useThreadsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useThreadsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get all threads for the current user
 */
export const useMyThreadsHook = () => {
        const myThreads = useCustomClient<ThreadsResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return myThreads(
          {url: `/api/threads/me`, method: 'GET', signal
    },
          );
        }, [myThreads])
      }
    

export const getMyThreadsQueryKey = () => {
    return [`/api/threads/me`] as const;
    }

    
export const useMyThreadsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMyThreadsQueryKey();

  const myThreads =  useMyThreadsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>> = ({ signal }) => myThreads(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MyThreadsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>>
export type MyThreadsQueryError = ErrorType<void>


export function useMyThreads<TData = Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMyThreads<TData = Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMyThreads<TData = Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all threads for the current user
 */

export function useMyThreads<TData = Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMyThreadsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useMyThreadsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Send a message
 */
export const useSendMessageHook = () => {
        const sendMessage = useCustomClient<MessageResponse>();

        return useCallback((
    threadId: string,
    messageRequest: BodyType<MessageRequest>,
 signal?: AbortSignal
) => {
        return sendMessage(
          {url: `/api/threads/${threadId}/conversation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: messageRequest, signal
    },
          );
        }, [sendMessage])
      }
    


export const useSendMessageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSendMessageHook>>>, TError,{threadId: string;data: BodyType<MessageRequest>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSendMessageHook>>>, TError,{threadId: string;data: BodyType<MessageRequest>}, TContext> => {
    
const mutationKey = ['sendMessage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const sendMessage =  useSendMessageHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useSendMessageHook>>>, {threadId: string;data: BodyType<MessageRequest>}> = (props) => {
          const {threadId,data} = props ?? {};

          return  sendMessage(threadId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendMessageMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSendMessageHook>>>>
    export type SendMessageMutationBody = BodyType<MessageRequest>
    export type SendMessageMutationError = ErrorType<void>

    /**
 * @summary Send a message
 */
export const useSendMessage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSendMessageHook>>>, TError,{threadId: string;data: BodyType<MessageRequest>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useSendMessageHook>>>,
        TError,
        {threadId: string;data: BodyType<MessageRequest>},
        TContext
      > => {

      const mutationOptions = useSendMessageMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get a conversation
 */
export const useConversationHook = () => {
        const conversation = useCustomClient<ConversationResponse>();

        return useCallback((
    threadId: string,
 signal?: AbortSignal
) => {
        return conversation(
          {url: `/api/threads/${threadId}/conversation`, method: 'GET', signal
    },
          );
        }, [conversation])
      }
    

export const getConversationQueryKey = (threadId: string,) => {
    return [`/api/threads/${threadId}/conversation`] as const;
    }

    
export const useConversationQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useConversationHook>>>, TError = ErrorType<void>>(threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useConversationHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConversationQueryKey(threadId);

  const conversation =  useConversationHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useConversationHook>>>> = ({ signal }) => conversation(threadId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(threadId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useConversationHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConversationQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useConversationHook>>>>
export type ConversationQueryError = ErrorType<void>


export function useConversation<TData = Awaited<ReturnType<ReturnType<typeof useConversationHook>>>, TError = ErrorType<void>>(
 threadId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useConversationHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useConversationHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useConversationHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConversation<TData = Awaited<ReturnType<ReturnType<typeof useConversationHook>>>, TError = ErrorType<void>>(
 threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useConversationHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useConversationHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useConversationHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConversation<TData = Awaited<ReturnType<ReturnType<typeof useConversationHook>>>, TError = ErrorType<void>>(
 threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useConversationHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a conversation
 */

export function useConversation<TData = Awaited<ReturnType<ReturnType<typeof useConversationHook>>>, TError = ErrorType<void>>(
 threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useConversationHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useConversationQueryOptions(threadId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Send feedback for a message
 */
export const useSendFeedbackHook = () => {
        const sendFeedback = useCustomClient<FeedbackResponse>();

        return useCallback((
    threadId: string,
    messageId: string,
    feedbackRequest: BodyType<FeedbackRequest>,
 signal?: AbortSignal
) => {
        return sendFeedback(
          {url: `/api/threads/${threadId}/conversation/${messageId}/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: feedbackRequest, signal
    },
          );
        }, [sendFeedback])
      }
    


export const useSendFeedbackMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSendFeedbackHook>>>, TError,{threadId: string;messageId: string;data: BodyType<FeedbackRequest>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSendFeedbackHook>>>, TError,{threadId: string;messageId: string;data: BodyType<FeedbackRequest>}, TContext> => {
    
const mutationKey = ['sendFeedback'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const sendFeedback =  useSendFeedbackHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useSendFeedbackHook>>>, {threadId: string;messageId: string;data: BodyType<FeedbackRequest>}> = (props) => {
          const {threadId,messageId,data} = props ?? {};

          return  sendFeedback(threadId,messageId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendFeedbackMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSendFeedbackHook>>>>
    export type SendFeedbackMutationBody = BodyType<FeedbackRequest>
    export type SendFeedbackMutationError = ErrorType<void>

    /**
 * @summary Send feedback for a message
 */
export const useSendFeedback = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSendFeedbackHook>>>, TError,{threadId: string;messageId: string;data: BodyType<FeedbackRequest>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useSendFeedbackHook>>>,
        TError,
        {threadId: string;messageId: string;data: BodyType<FeedbackRequest>},
        TContext
      > => {

      const mutationOptions = useSendFeedbackMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get feedback history for a thread
 */
export const useFeedbackHistoryHook = () => {
        const feedbackHistory = useCustomClient<FeedbackHistoryResponse>();

        return useCallback((
    threadId: string,
 signal?: AbortSignal
) => {
        return feedbackHistory(
          {url: `/api/threads/${threadId}/conversation/feedback`, method: 'GET', signal
    },
          );
        }, [feedbackHistory])
      }
    

export const getFeedbackHistoryQueryKey = (threadId: string,) => {
    return [`/api/threads/${threadId}/conversation/feedback`] as const;
    }

    
export const useFeedbackHistoryQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>, TError = ErrorType<void>>(threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeedbackHistoryQueryKey(threadId);

  const feedbackHistory =  useFeedbackHistoryHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>> = ({ signal }) => feedbackHistory(threadId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(threadId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FeedbackHistoryQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>>
export type FeedbackHistoryQueryError = ErrorType<void>


export function useFeedbackHistory<TData = Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>, TError = ErrorType<void>>(
 threadId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeedbackHistory<TData = Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>, TError = ErrorType<void>>(
 threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFeedbackHistory<TData = Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>, TError = ErrorType<void>>(
 threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get feedback history for a thread
 */

export function useFeedbackHistory<TData = Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>, TError = ErrorType<void>>(
 threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFeedbackHistoryHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useFeedbackHistoryQueryOptions(threadId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get tracing by component name
 */
export const useTracingHook = () => {
        const tracing = useCustomClient<TracesResponse>();

        return useCallback((
    componentName: string,
 signal?: AbortSignal
) => {
        return tracing(
          {url: `/api/tracing/${componentName}`, method: 'GET', signal
    },
          );
        }, [tracing])
      }
    

export const getTracingQueryKey = (componentName: string,) => {
    return [`/api/tracing/${componentName}`] as const;
    }

    
export const useTracingQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useTracingHook>>>, TError = ErrorType<void>>(componentName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTracingHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTracingQueryKey(componentName);

  const tracing =  useTracingHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useTracingHook>>>> = ({ signal }) => tracing(componentName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(componentName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTracingHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TracingQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useTracingHook>>>>
export type TracingQueryError = ErrorType<void>


export function useTracing<TData = Awaited<ReturnType<ReturnType<typeof useTracingHook>>>, TError = ErrorType<void>>(
 componentName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTracingHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTracingHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTracingHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTracing<TData = Awaited<ReturnType<ReturnType<typeof useTracingHook>>>, TError = ErrorType<void>>(
 componentName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTracingHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTracingHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTracingHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTracing<TData = Awaited<ReturnType<ReturnType<typeof useTracingHook>>>, TError = ErrorType<void>>(
 componentName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTracingHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get tracing by component name
 */

export function useTracing<TData = Awaited<ReturnType<ReturnType<typeof useTracingHook>>>, TError = ErrorType<void>>(
 componentName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTracingHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useTracingQueryOptions(componentName,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get tracing by component name and thread id
 */
export const useTracingByThreadIdHook = () => {
        const tracingByThreadId = useCustomClient<TracesResponse>();

        return useCallback((
    componentName: string,
    threadId: string,
 signal?: AbortSignal
) => {
        return tracingByThreadId(
          {url: `/api/tracing/${componentName}/${threadId}`, method: 'GET', signal
    },
          );
        }, [tracingByThreadId])
      }
    

export const getTracingByThreadIdQueryKey = (componentName: string,
    threadId: string,) => {
    return [`/api/tracing/${componentName}/${threadId}`] as const;
    }

    
export const useTracingByThreadIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>, TError = ErrorType<void>>(componentName: string,
    threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTracingByThreadIdQueryKey(componentName,threadId);

  const tracingByThreadId =  useTracingByThreadIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>> = ({ signal }) => tracingByThreadId(componentName,threadId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(componentName && threadId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TracingByThreadIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>>
export type TracingByThreadIdQueryError = ErrorType<void>


export function useTracingByThreadId<TData = Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>, TError = ErrorType<void>>(
 componentName: string,
    threadId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTracingByThreadId<TData = Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>, TError = ErrorType<void>>(
 componentName: string,
    threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTracingByThreadId<TData = Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>, TError = ErrorType<void>>(
 componentName: string,
    threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get tracing by component name and thread id
 */

export function useTracingByThreadId<TData = Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>, TError = ErrorType<void>>(
 componentName: string,
    threadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTracingByThreadIdHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useTracingByThreadIdQueryOptions(componentName,threadId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




